import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateModule } from '@ngx-translate/core';
import { ThaiDatePipe } from '@app/shared/thaidate.pipe'
import { ReactiveFormsModule } from '@angular/forms';
import { HighlightSearchPipe } from '@app/shared/HighlightSearchPipe.pipe'


import { environment } from '@env/environment';
import { CoreModule, HttpService } from '@app/core';
import { RouterModule, Routes } from '../../node_modules/@angular/router';
import { AppComponent } from './app.component';

import { AuthGuard } from '@app/auth.guard';
import { AuthService } from '@app/auth.service';

import { UserService } from '@app/user.service';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { LoginComponent } from '@app/account/login/login.component';
import { MainmenuComponent } from './mainmenu/mainmenu.component';

import { UtilService } from './utility/util.service';
import { MasterService } from './utility/master.service';
import { ApiService } from './utility/api.service';
import { ExcelService } from './excel.service';
import { NoCacheHeadersInterceptorService } from '@app/no-cache-headers-interceptor.service'

import { ContactComponent } from './contact/contact.component';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { SocialMediaMonitorComponent } from './social-media-monitor/social-media-monitor.component';
import { KnowledgeBaseComponent } from './knowledge-base/knowledge-base.component';
import { ReportComponent } from './report/report.component';
import { SettingComponent } from './setting/setting.component';
import { NewsComponent } from './news/news.component';
import { SideMainMenuComponent } from './side-main-menu/side-main-menu.component';
import { CaseComponent } from './case/case.component';
import { SharedCaseComponent } from './shared-case/shared-case.component';
import { ContactHistoryComponent } from './contact-history/contact-history.component';
import { DepositorInfoComponent } from './depositor-info/depositor-info.component';
import { CustomerProfileComponent } from './customer-profile/customer-profile.component';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { NewCaseComponent } from './new-case/new-case.component';
import { CustomerComponent } from './customer/customer.component';
import { ForgotPasswordComponent } from './account/forgot-password/forgot-password.component';
import { IncomingCallComponent } from './incoming-call/incoming-call.component';
import { IncomingContactComponent } from './incoming-contact/incoming-contact.component';
import { PoolCaseComponent } from './pool-case/pool-case.component';
import { ForwardCaseComponent } from './forward-case/forward-case.component';
import { DownloadFileComponent } from './download-file/download-file.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SetNewPasswordComponent } from './set-new-password/set-new-password.component';
import { SetChangePasswordComponent } from './set-change-password/set-change-password.component';
import { CreateNewPasswordComponent } from './create-new-password/create-new-password.component';
import { CryptographyService } from '@app/cryptography.service';
import { CustomerReqDocComponent } from './customer-req-doc/customer-req-doc.component';
import { CustomerDaDataComponent } from './customer-da-data/customer-da-data.component';
import { CustomerEditComponent } from './customerEdit/customerEdit.component';


const appRoutes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login', component: LoginComponent
  },
  {
    path: 'mainmenu', component: MainmenuComponent,
    children: [
      { path: 'pool', component: PoolCaseComponent, canActivate: [AuthGuard] },
      { path: 'shared', component: SharedCaseComponent, canActivate: [AuthGuard] },
      { path: 'case', component: CaseComponent, canActivate: [AuthGuard] },
      { path: 'contact', component: ContactComponent, canActivate: [AuthGuard] },
      { path: 'chatbot', component: ChatbotComponent, canActivate: [AuthGuard] },
      { path: 'socialMedia', component: SocialMediaMonitorComponent, canActivate: [AuthGuard] },
      { path: 'knowledge', component: KnowledgeBaseComponent, canActivate: [AuthGuard] },
      { path: 'report', component: ReportComponent, canActivate: [AuthGuard] },
    ]
  },
  {
    path: 'news/:id', component: NewsComponent, canActivate: [AuthGuard]
  },
  {
    path: 'customer/:id', component: CustomerComponent, canActivate: [AuthGuard]
  },
  {
    path: 'newCase', component: NewCaseComponent, canActivate: [AuthGuard]
  },
  {
    path: 'newCaseChatbot', component: NewCaseComponent, canActivate: [AuthGuard]
  },
  {
    path: 'caseDetail/:id', component: NewCaseComponent, canActivate: [AuthGuard]
  },
  {
    path: 'newContact', component: NewCaseComponent, canActivate: [AuthGuard]
  },
  {
    path: 'newCaseForContact/:id', component: NewCaseComponent, canActivate: [AuthGuard]
  },
  {
    path: 'changePassword', component: ForgotPasswordComponent, canActivate: [AuthGuard]
  },
  {
    path: 'resetPassword', component: ResetPasswordComponent
  },
  {
    path: 'setNewPassword', component: SetNewPasswordComponent
  },
  {
    path: 'customerEdit', component: CustomerEditComponent
  },
  {
    path: 'setChangePassword', component: SetChangePasswordComponent
  },
  {
    path: 'createNewPassword', component: CreateNewPasswordComponent
  },
  {
    path: 'incomingCall', component: IncomingCallComponent, canActivate: [AuthGuard]
  },
  {
    path: 'incomingContact', component: IncomingContactComponent, canActivate: [AuthGuard]
  },
  {
    path: 'downloadFile', component: DownloadFileComponent, canActivate: [AuthGuard]
  },
  // {
  //   path: 'sidemainmenu', component: SideMainMenuComponent,
  //   children: [
  //     { path: 'contact', component: ContactComponent },
  //     { path: 'contactReport', component: ContactReportComponent },
  //     { path: 'chatbot', component: ChatbotComponent },
  //     { path: 'socialMedia', component: SocialMediaMonitorComponent },
  //     { path: 'knowledge', component: KnowledgeBaseComponent },
  //     { path: 'report', component: ReportComponent },
  //   ]
  // }
];

@NgModule({
  imports: [
    BrowserModule,
    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpModule,
    TranslateModule.forRoot(),
    CoreModule,
    RouterModule.forRoot(
      appRoutes
    )
  ],
  declarations: [AppComponent,
    LoginComponent,
    MainmenuComponent,
    ContactComponent,
    ChatbotComponent,
    SocialMediaMonitorComponent,
    KnowledgeBaseComponent,
    ReportComponent,
    SettingComponent,
    NewsComponent,
    SideMainMenuComponent,
    CaseComponent,
    SharedCaseComponent,
    ContactHistoryComponent,
    DepositorInfoComponent,
    CustomerProfileComponent,
    CustomerDetailComponent,
    NewCaseComponent,
    CustomerComponent,
    ThaiDatePipe,
    ForgotPasswordComponent,
    IncomingCallComponent,
    IncomingContactComponent,
    HighlightSearchPipe,
    PoolCaseComponent,
    ForwardCaseComponent,
    DownloadFileComponent,
    ResetPasswordComponent,
    SetNewPasswordComponent,
    SetChangePasswordComponent,
    CreateNewPasswordComponent,
    CustomerReqDocComponent,
    CustomerDaDataComponent,
    CustomerEditComponent
  ],
  providers: [
    AuthService, 
    UtilService, 
    MasterService, 
    AuthGuard, 
    UserService, 
    ApiService, 
    ExcelService,
    CryptographyService, 
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheHeadersInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts